<template>
  <div>
    <div class="animated fadeIn features">
      <b-card no-body  class="received-form">
        <div class="features-table">
          <SearchBar @filterInput="setFilter" @update:editByValue="editByUserName" v-bind:editedOptions="editedOptions" :editedByValue="editedByValue" title="Features Flags"/>
          <b-table show-empty striped :empty-text="$t('COMMON.NO_RECORD')" hover responsive="sm" variant="danger" :items="sortedFeatureFlags"  :filter="filter" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
            <template slot="HEAD_is_enabled" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
            <template slot="is_enabled" slot-scope="data">
              <cSwitch
                type="3d"
                variant="success"
                :checked="data.item.is_enabled"
                @change="updateIndividualFeatureFlag($event,data.item)"
              />
            </template>
          </b-table>
        </div>
      </b-card>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { getAllFeatureFlags, updateFeatureFlag } from '@/apiServices/featureFlagService.js'
import TableLoading from './TableLoading.vue'
import Multiselect from 'vue-multiselect'
import cSwitch from '@/components/Switch'
import Vue from 'vue'
import SearchBar from '../../components/utils/FeaturesSearchBar.vue'
export default {
  components: {
    TableLoading,
    Multiselect,
    SearchBar,
    cSwitch
  },
  data () {
    return {
      featureFlag: {
        isLoading: false,
        isError: false,
        data: []
      },
      sortBy: 'id',
      sortDesc: false,
      searchName: '',
      description: '',
      account: '',
      searchLastEditedby: [],
      searchIsEnabled: {
        enabled: false,
        value: undefined
      },
      filter: null,
      editedOptions: [],
      editedByValue: [],
      tableFields: [
        { key: 'id', sortable: true },
        { key: 'name', label: 'Name', sortable: false },
        { key: 'description', label: 'description', sortable: false },
        { key: 'account_name', label: 'account_name', sortable: false },
        { key: 'last_edited_by', label: 'Last Edited By', sortable: false },
        { key: 'is_enabled', label: 'Status', sortable: false }
      ]
    }
  },
  created () {
    this.getFeatureFlagData()
  },
  computed: {
    filteredFeatureFlags () {
      if (this.featureFlag.data.length) {
        let filteredFlags = this.featureFlag.data
        if (this.searchName.length) {
          filteredFlags = filteredFlags.filter(flag => flag.name.toLowerCase().includes(this.searchName.toLowerCase()))
        }
        if (this.description.length) {
          filteredFlags = filteredFlags.filter(flag => (flag.description ? flag.description.toLowerCase() : '').includes(this.description.toLowerCase()))
        }
        if (this.account.length) {
          filteredFlags = filteredFlags.filter(flag => flag.account_name.toLowerCase().includes(this.account.toLowerCase()))
        }
        if (this.editedByValue.length) {
          let tempFilteredFlags = []
          filteredFlags.forEach((element) => {
            for (const selectedEditedOption of this.editedByValue) {
              if (selectedEditedOption.title === element.last_edited_by) {
                tempFilteredFlags.push(element)
                break
              }
            }
          })
          filteredFlags = tempFilteredFlags
        }
        if (this.searchIsEnabled.value !== undefined) {
          const tempSearchIsEnabled = this.searchIsEnabled.value === 'true'
          filteredFlags = filteredFlags.filter(flag => flag.is_enabled === tempSearchIsEnabled)
        }
        return filteredFlags
      }
      return []
    },
    sortedFeatureFlags () {
      return this.filteredFeatureFlags.sort((a, b) => a.id - b.id)
    },
    ...mapGetters(['idToken'])
  },
  methods: {
    setFilter (filter) {
      this.filter = filter
    },
    editByUserName (value) {
      this.editedByValue = value
    },
    async getFeatureFlagData () {
      try {
        this.featureFlag.isLoading = true
        this.featureFlag.data = await getAllFeatureFlags(this.idToken)
        let tempEditedByOptions = new Set()
        this.featureFlag.data.forEach(element => {
          tempEditedByOptions.add(element.last_edited_by || '-')
        })
        Array.from(tempEditedByOptions).forEach((element) => { this.editedOptions.push({ title: element }) })
      } catch (error) {
        this.featureFlag.isError = true
      } finally {
        this.featureFlag.isLoading = false
      }
    },
    async updateIndividualFeatureFlag (event, selectedFeatureFlag) {
      selectedFeatureFlag.is_enabled = event
      try {
        let respData = await updateFeatureFlag(this.idToken, selectedFeatureFlag)
        let updatedFeatureFlag = respData.feature_flag
        this.featureFlag.data.map((featureData) =>
          featureData.id === updatedFeatureFlag.id ? updatedFeatureFlag : featureData)
        Vue.toasted.show(`${updatedFeatureFlag.name} is ${updatedFeatureFlag.is_enabled ? 'Disabled' : 'Enabled'}`, {type: `success`})
      } catch (error) {
        this.featureFlag.isError = true
        Vue.toasted.show('Error Please Try Again', {type: `error`})
      } finally {
      }
    },
    customLabel ({ title }) {
      return `${title}`
    },
    isSelected (currentTitle) {
      for (const element of this.editedByValue) {
        if (element.title === currentTitle) {
          return true
        }
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.features {
  .card {
    .dash-box:hover {
      background: #0e2547 !important;;
    }
    cursor: pointer;
    border-radius: 10px;
    .bar {
      width: 100%;
      height: 10px;
      border-radius: 10px 10px 0 0;
    }

    .card-header {
      border-radius: 10px 10px 0 0;
      background-color: #0e2547;
      padding: 1rem;
    }
  }
}
.filterTitle{
  font-size: large;
  font-family: 'Lato' !important;
  font-weight: 600;
}
.filter-title{
  display: flex;
  gap: 10px
}
.featureflag-container{
  display: flex;
  margin-bottom: 10px
}
.filter-container{
  display: flex;
  gap: 10px;
  margin-left: auto;
  flex-direction: column;
}
.typo__label{
  font-family: 'Lato' !important;
  font-weight: 600;
  font-size: 14px;
}
.multiselect__tags {
 padding-top: 0px !important;
}
.multiselect__input{
  margin-bottom: 0px;
}
.switch-success > .switch-input:checked ~ .switch-label{
  background: #0e2547 !important;
  border-color:#0e2547 !important;
}
.multiselect{
    width: 300px;
}
.avatar{
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #f9cb9a;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #262e38;
    margin: 8px;
}
.option__desc{
    display: flex;
    align-items: center;
    gap: 5px;
}
li .multiselect__element{
    align-items: center;
    height: 40px !important;
}
.multiselect__tag{
    background: #0e2547 !important;
}
.multiselect__tag:after{
        color: #ddd !important;
}
.multiselect__option{
    padding: 0px !important;
}
.multiselect__content{
    display: flex;
    flex-direction: column;
}
.multiselect__tag-icon:focus, .multiselect__tag-icon:hover{
  background: #0e2547 !important;
}
.test{
  width: 200px;
}
.multiselect__option--highlight {
  background-color: #0e2547 !important;
}
.container-modal {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  display: flex;
}
.modal {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 500px;
  height: 500px;
  background-color: red;
}
select {
  /* styling */
  background-color: white;
  border-color: rgb(9, 30, 66) !important;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 0.5em 3.5em 0.5em 1em;
  /* reset */
  margin: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
select {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 2px),
    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}
select:focus {
  background-image: linear-gradient(45deg, green 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, green 50%),
    linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em,
    calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: green;
  outline: 0;
}
input {
  background-color: rgb(250, 251, 252);
  border-color: rgb(223, 225, 230);
  color: rgb(9, 30, 66);
  cursor: text;
  border-radius: 3px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.42857;
  padding: 8px 6px;
  height: 36px;
  border-color: rgb(9, 30, 66);
}
input:focus-visible {
  border-color: rgb(9, 30, 66) !important;
  outline-color: rgb(9, 30, 66) !important;
}
.features-table {
  max-height: 50.5rem;
  overflow-y: scroll;
  border-radius: 0 0 10px 10px;
}
.table {
  margin-bottom: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/featureflag/FeatureFlag.vue